import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageService } from '@app/services';
import { JwtHelper } from './jwt.helper';
import { WindowScrollController } from '@fullcalendar/core';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private serviceStorage: StorageService,
    private helper: JwtHelper,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Adiciona o Header Authorization com o Token JWT
    const currentToken = this.serviceStorage.getAccess().token;
    if (currentToken) {
      if(this.helper.getIsExpired())
      {
        alert("Sessão expirada.\nFavor fazer o login novamente no portal do aluno.");
        window.close();
      }
      else
      {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${currentToken}`,
          },
        });
      }
    }
    return next.handle(request);
  }
}

